/**
 * Context that lets EntityChip components deep in the tree fire
 * "open this entity" without prop-drilling. AppShell provides the
 * concrete handler; anything rendered outside the provider gets a
 * no-op so chips don't crash in isolation.
 */

import { createContext, useContext } from "react";
import type { ReactNode } from "react";

export type MentionKind =
  | "note"
  | "task"
  | "event"
  | "habit"
  | "shopping_list"
  | "shopping_item"
  | "recipe";

interface MentionContextValue {
  onMentionClick(kind: MentionKind, id: string): void | Promise<void>;
}

const Ctx = createContext<MentionContextValue | null>(null);

interface MentionProviderProps {
  value: MentionContextValue;
  children: ReactNode;
}

export function MentionProvider({ value, children }: MentionProviderProps): JSX.Element {
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useMentionClick(): (kind: MentionKind, id: string) => void | Promise<void> {
  const ctx = useContext(Ctx);
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  return ctx?.onMentionClick ?? (() => {});
}
